import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IFreeGamesData from "../../model/IFreeGamesData";

export default class PromotionalFreeGamesDataParser implements IBaseDataParser<IFreeGamesData> {
    check(data: any): boolean {
        return (
            data &&
            data.Response &&
            data.Response.FreeGames &&
            (data.Response.FreeGames.Games  || data.Response.FreeGames.CurrentGame)
        );
    }
    parse(data: any): IFreeGamesData | IFreeGamesData[] {

        let freeGamesData =  data.Response.FreeGames.Games ? data.Response.FreeGames.Games.FreeGame : data.Response.FreeGames.CurrentGame;

        freeGamesData = Array.isArray(freeGamesData)
            ? freeGamesData
            : [freeGamesData];

       
        let currentPromotion = freeGamesData[0];
        let betInfo = currentPromotion.DefaultBet;
        let result = {
            offerId: currentPromotion.attributes.offerId,
            currentBetMultiplier: betInfo?parseInt(betInfo.attributes.coins):0,
            coinSize: betInfo?parseInt(betInfo.attributes.chipSize):0,
            totalBet: betInfo?parseInt(currentPromotion.attributes.maxCost):0,
            sumWinnings: currentPromotion.attributes.sumWinnings,
            freeGamesCount: parseInt(currentPromotion.attributes.gamesRemaining),
            instanceId: currentPromotion.attributes.instanceId,
            gamesPlayed: parseInt(currentPromotion.attributes.gamesPlayed),
            gamesAwarded: parseInt(currentPromotion.attributes.gamesAwarded),
        }


        return result;

    }

}